import { projectStyledName } from 'shared/constants'

import { localeProfileType } from '../en-US'

/* eslint-disable max-len */
export const profile: localeProfileType = {
  spinHistory: 'Historial de giros',
  profile: 'Perfil',
  dateFrom: 'Que data de',
  illegalDateOfBirth: 'Tu edad debe ser mayor de 18 años',
  show: 'Mostrar',
  selectPeriod: 'Seleccionar período',
  from: 'De',
  to: 'Para',
  bet: 'Apuesta',
  win: 'Ganar',
  game: 'Juego',
  savePassword: 'Guardar contraseña',
  sportFreeSpins: 'Deporte y giros gratis',
  transferBonus: 'Transferir bono',
  promotions: 'Promociones',
  cash: 'Efectivo',
  promocode: 'Código promocional',
  basicInformation: 'Información básica',
  email: 'Dirección de correo electrónico',
  login: 'Iniciar sesión',
  name: 'Nombre',
  dateOfRegistration: 'Fecha de registro',
  empty: 'vacío*',
  required: 'requerido *',
  invalidEmail: 'correo electrónico no válido*',
  m: 'Masculino',
  f: 'Mujer',
  changePrivacy: 'Cambiar configuración de privacidad',
  countryLabel: 'País (formato de dos letras)',
  replenishment: 'Reposición',
  backToProfile: 'Volver al perfil',
  betHistory2: 'Bet history',
  myBonus: 'Mi bonificación',
  withdraw: 'Retirar',
  transactions: 'Transacciones',
  kyc: 'Verificación de cuenta',
  limits: 'Límites',
  selfExclusion: 'Cerrar una cuenta',
  userInfo: 'Datos personales',
  lk: 'Su cuenta',
  activePromotions: 'Activo',
  available: 'Disponible',
  expired: 'Caducado',
  completed: 'Completado',
  accountNum: 'Número de cuenta',
  gender: 'Género',
  balance: 'Equilibrio',
  bonusBalance: 'Saldo de bonificación',
  fullName: 'Nombre completo',
  currency: 'Moneda',
  betslip: 'Boleta de apuestas',
  bonusHistory: 'Historial de bonificaciones',
  cashbackHistory: 'Historial de reembolsos',
  additionalInfo: 'Información adicional',
  yandex: 'Yandex (número de cuenta)',
  card: 'Tarjeta VISA / MASTER CARD (número de cuenta)',
  phone: 'Número de teléfono',
  numberDocument: 'Número del documento',
  address: 'Dirección de registro',
  save: 'Guardar',
  cancel: 'Cancelar',
  infoWasUpdated: 'Información actualizada con éxito',
  changePassword: 'Cambio de contraseña',
  changePasswordAdditional: 'Cambiar la contraseña de su cuenta',
  enterOldPassword: 'Contraseña actual',
  repeatNewPassword: 'Repetir nueva contraseña',
  enterNewPassword: 'Nueva contraseña',
  confirmNewPassword: 'Nueva contraseña(Confirmar)',
  topUp: 'Cuenta de recarga',
  withdrawalMoney: 'Retirar dinero',
  chooseSport: 'Elige deporte',
  sportBetting1: 'Apuestas deportivas 1',
  sportBetting2: 'Apuestas deportivas 2',
  liveBetting1: 'Apuestas en vivo 1',
  liveBetting2: 'Apuestas en vivo 2',
  betHistory1: 'Historial de apuestas 1',
  betHistory3: 'Historial de apuestas 3',
  withdrawal: 'Retirar dinero',
  payHistory: 'Historial de operaciones',
  betHistory: 'Historial de apuestas',
  slotsHistory: 'Historia de las tragamonedas',
  promotionalCodes: 'Activar código promocional',
  logout: 'Cerrar sesión',
  changedPassword: 'El cambio de contraseña es exitoso',
  changedPasswordDoNotMatch: 'Las contraseñas no coinciden',
  promotionalCodesAdditional: 'Ingrese un código promocional para recibir bonificaciones',
  betHistoryAdditional: 'Todas tus apuestas recientes',
  payHistoryAdditional: 'Todas las operaciones que afectaron al cambio de saldo',
  additionalInfoAdditional: 'Posibilidad de agregar nombre, fecha de nacimiento y número de teléfono',
  ourCashiersAdditional: 'Direcciones de nuestras cajas',
  ourCashiers: 'Nuestra taquilla',
  country: 'País',
  seriesDocument: 'Una serie de documentos',
  documentNumber: 'Número del documento',
  exit: 'Sal',
  exitAdditional: 'Cerrar sesión',
  registrationAddress: 'Dirección de registro',
  firstName: 'Nombre',
  lastName: 'Apellido',
  middleName: 'Segundo nombre',
  birthDate: 'Fecha de nacimiento',
  city: 'Ciudad',
  phoneInfo:
    'Después de que el teléfono haya sido aceptado, su inicio de sesión no debe registrarse antes en el sitio.',
  dataIsNotEditable:
    'La edición de los datos de registro no está disponible . Póngase en contacto con el soporte técnico.',
  personal: 'Personal',
  favoriteLinks: 'Enlaces favoritos',
  accountActivity: 'Actividad de la cuenta',
  personalDetails: 'Datos personales',
  personalInformation: 'Información personal',
  currentPassword: 'Contraseña actual',
  oldPasswordMissing: 'Falta la contraseña anterior',
  newPasswordMissing: 'Falta una nueva contraseña',
  newPassword: 'Nueva contraseña',
  newPasswordConfirmation: 'Nueva contraseña(Confirmar)',
  payment: 'Pagos',
  contactDetails: 'Datos de contacto',
  accountSettings: 'Configuración de la cuenta de usuario',
  playersActivities: 'Actividades de los jugadores',
  payments: 'Pagos',
  bookmakersSettings: 'Configuración de las Casas de apuestas',
  username: 'Nombre de usuario',
  edit: 'Editar',
  reqForPasswordTitle: 'Requisitos para una contraseña válida',
  reqForPassword1: 'debe constar de al menos 5, como máximo 40 caracteres',
  reqForPassword2: 'caracteres especiales permitidos:!#$()@?{}|*+,^.-+&=%_:;~',
  reqForPassword3: 'no puede contener espacios',
  reqForPassword4:
    'no puede ser similar o contener otros datos personales (por ejemplo, nombre, apellido, nombre de usuario, etc.)',
  tips: 'Consejos',
  tips1: 'las contraseñas más largas y complejas son más seguras',
  tips2: 'seleccione la contraseña que no usa para iniciar sesión en otras cuentas en línea',
  tips3: 'no comparta la contraseña con otros',
  passwordStrength: 'Seguridad de la contraseña',
  title: 'Título',
  dateOfBirth: 'Fecha de nacimiento (MM-DD-AAAA)',
  street: 'Calle',
  houseNumber: 'Número de casa',
  zipCode: 'Código postal',
  townCity: 'Pueblo/ciudad',
  contactLanguage: 'Idioma de contacto',
  mobilePhone: 'Número de teléfono móvil',
  userData: 'Datos del usuario',
  myBets: 'Mis apuestas',
  fundsTransfer: 'Transferencia de fondos',
  informationForPassword: 'Información para la contraseña',
  questions: 'Preguntas',

  gameProfile: 'Perfil de juego',
  responsibleGame: 'Juego responsable',
  depositAndWithdrawal: 'Depósito y retiro',
  callUs: 'Llámanos',
  contactUs: 'Contáctanos vía Telegram',
  sendEmail: 'Envíenos un correo electrónico',
  contactUsChat: 'Contáctanos por Whatsapp',
  cantFind: '¿No encuentras lo que buscas?',
  example: 'Ejemplo',
  send: 'Enviar',
  acceptedFormats: 'Formatos aceptados',
  maximumSize: 'Tamaño máximo',

  pleaseSelectFile: 'Seleccione un archivo',
  kycSendedSuccess: 'El archivo se ha enviado correctamente',
  exchangeBonusBalance: 'Saldo de bonificación de intercambio',
  id: 'ID',
  time: 'Tiempo',
  type: 'Tipo',
  description: 'Descripción',
  noData: 'No se muestran datos !',
  editProfile: 'Editar perfil',
  bonusTransfer: 'Bono de transferencia',
  totalFunds: 'Fondos totales',
  myWidgets: 'Mis widgets',
  close: 'Cerrar',
  tel: 'Tel',
  code: 'Código',
  statement: 'Declaración',
  deposit: 'Depósito',
  filter: 'Filtro',
  startDate: 'Fecha de inicio',
  endDate: 'Fecha de finalización',
  reload: 'Recargar',
  count: 'Contar',
  amount: 'Importe',
  balanceDetails: 'Detalles del saldo',
  details: 'Detalles',
  transactionType: 'Tipo de transacción',
  view: 'Ver',
  total: 'Total',
  manualTransferUp: 'Transferencia Manual Hacia Arriba',
  overdraft: 'Sobregiro',
  pendings: 'Pendiente',
  myBet: 'Mi apuesta',
  exchangeSuccess: 'Intercambio exitoso',
  exchangeBonusToBalance: 'Bono de Intercambio para Equilibrar',
  amountBonusLess: 'Cantidad de bonificación menos 3 PYG',
  exchange: 'Intercambio',
  balanceMore: 'La transferencia está disponible si el saldo es inferior a',
  transferSuccess: 'Con éxito, el dinero se ha acreditado en su saldo',
  sessions: 'Sesiones',
  date: 'Fecha',
  myProfile: 'Mi perfil',
  transactionHistory: 'Historial de Transacciones',
  transactionDetail: 'Detalle de la transacción',
  signUp: 'Regístrate',
  transactionId: 'Id de transacción',
  provider: 'Proveedor',
  oldBalance: 'Viejo equilibrio',
  newBalance: 'New Balance',
  status: 'Estado',
  allTransactions: 'Todas las transacciones',
  dateRange: 'Intervalo de fechas',
  transactionsType: 'Tipo de transacción',
  back: 'Atrás',
  page: 'Página',
  balanceBefore: 'Equilibrio antes',
  balanceAfter: 'Equilibrio después',
  transaction_replenishment: 'Reposición',
  TransferBonusesToBalance: 'Transferir bonificaciones al saldo',
  IncreasedBySO: 'Reposición por SO',
  cashback: 'Devolución de dinero',
  SportDiscount: 'Descuento deportivo',
  FirstDeposit: 'Primer depósito',
  DetractedFirstDepositBonusByWithdrawal: 'Bono De Primer Depósito Detraído Por Retiro',
  bonusAmount: 'Importe de la bonificación',
  IncreasedByOwner: 'Reposición',
  PersonalJackpot: 'Premio gordo personal',
  amountLess: 'Importe inferior al mínimo',
  all: 'Todos',

  providerNames: {
    all: 'Todos',
    Sports: 'Deportes',
    otherSlots: 'Otras tragamonedas',
  },

  sftBetStatuses: {
    Wait: 'Espera',
    Loser: 'Perdido',
    Voided: 'Devuelto',
    Winner: 'Ganar',
    Done: 'Ganar',
    Cancelled: 'Cancelado',
  },

  openGamingAccountTextOne: `Cómo abrir una cuenta de juego de ${projectStyledName}? Cómo hacer un depósito o retirar fondos?
  En esta sección encontrará respuestas a estas y otras preguntas frecuentes.`,
  openGamingAccountTextTwo: `Sin embargo, si no ha encontrado la respuesta a su pregunta, nuestro apoyo y
  ¡el equipo de servicio al cliente estará encantado de ayudarlo!`,

  'invalid-size': 'El tamaño del archivo no cumple con los límites',
  'invalid-type': 'El tipo de archivo no es válido',

  faq: {
    gameProfile: {
      item1: {
        heading: "Can't sign in?",
        text1: 'Your gaming profile may be blocked because The wrong password has been entered multiple times.',
        text2:
          "Don't worry, the account has been blocked for security purposes. Contact our support center using the Live Chat option or email us",
        text3:
          'Your profile may be blocked because the closing period you requested has not yet ended. In this case, our support center will not be able to restore your game profile and you will need to wait until the set closing time expires.',
      },
      item2: {
        heading: 'Need a break or want to close your gaming profile?',
        text1: "We're sorry you want to close your gaming profile, but we respect your choice.",
        text2: 'Contact our support center so that we can offer you a suitable option to close your profile.',
        text3: "Don't forget to enter your details: ID and username.",
      },
      item3: {
        heading: 'Why were you asked for documents?',
        text1:
          'For security reasons and based on legal requirements, we may ask you to send us documents to verify your gaming profile. This is a standard procedure during which we may request: a photo of an identity card (ID card or passport), bank account confirmation (payment order from your bank), a photo of a payment / credit card.',
        text2: 'You will receive an e-mail notification from us about which documents you need to provide.',
      },
    },
    paymentProfile: {
      item1: {
        heading: 'Deposit',
        text1: 'We offer fast deposit methods:',
        li1: 'Deposit by bank card (Visa/MasterCard). Minimum deposit amount 5 EUR',
        li2: 'Deposit through available cryptocurrencies',
        text2:
          'If your deposit has not been added to your gaming profile, feel free to contact the support center and prepare a payment order in PDF format or a screenshot with all the details of the payment.',
        text3: 'Important! Deposits can only be made from your credit cards and bank accounts registered in your name.',
      },
      item2: {
        heading: 'Withdrawal',
        text1:
          'Payment can be requested to the card number, which is indicated in the withdrawal request form. Or to the wallet of one of the cryptocurrencies available for withdrawal. Funds will be lost if the wrong wallet is specified.',
        text2: 'Payments are confirmed from our side within the next hour after your request.',
        text3:
          'Bank funds are received within 5 minutes after confirmation from our side. Due to various circumstances, the payment may be delayed.',
        text4: 'The minimum amount you can request is 10 EUR.',
        // text5: 'If you have any questions, please contact us via email support@tunbet7.com',
        text5: '',
      },
      item3: {
        heading: 'Why was your payout cancelled?',
        text1: 'It may take up to 24 hours for us to confirm the payment.',
        text2:
          'We may contact you by e-mail and request some documents to verify your gaming profile. If you have been asked for documents, you will need to wait while we check them and confirm the requested payment. This procedure may take up to 24 hours.',
        text3:
          'You have the opportunity to contact our support center if you have additional questions regarding the verification of documents.',
      },
      item4: {
        heading: 'Closed loop principle',
        text1: 'We use a closed loop principle that applies to payouts in the following ways:',
        li1text1: 'Withdrawal must be requested by the method used for the last deposit.',
        li1text2: 'Last deposit from a Visa bank card → payout to a Visa bank card',
        li2text1:
          'If the player has multiple payout methods available, then the payout can be split between the methods as follows: the player must claim the full amount of the deposit from which the winnings were received, for the deposit method last used before winning. The rest of the amount can be requested in any other verified way.',
        li2text2:
          '€100 winnings received from a deposit of €20 with a Visa bank card → 1. payout to a Visa bank card in the amount of €20 (deposit amount) → 2. payout to a cryptocurrency wallet €80 (balance of winnings)',
        li3text1: 'We reserve the right to decide which payout method should be used.',
      },
    },
  },
  bonus: 'Bonificación',
}
